class PaneGroup {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-pane-group]',
			breakpoint: 992,
		}, config);

		this.scope = document.querySelectorAll(this.config.scope);

		if (this.scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.scope.forEach(group => {
			const panes = group.querySelectorAll('[data-pane]');

			if (window.innerWidth >= this.config.breakpoint) {
				this.#initDesktop(panes);
			} else {
				this.#initMobile(panes);
			}
		});
	}

	#initDesktop(panes) {
		panes.forEach(pane => {
			pane.addEventListener('click', () => {
				if (pane.classList.contains('is-active')) return;

				const currentActive = [...panes].find(p => p.classList.contains('is-active'));

				const closingPaneShow = currentActive?.querySelector('.pane-show');
				if (closingPaneShow) {
					closingPaneShow.style.transition = 'none';
					closingPaneShow.style.opacity = '0';
					closingPaneShow.style.gridTemplateRows = '0fr';
				}

				pane.classList.add('is-transitioning');

				setTimeout(() => {
					panes.forEach(p => p.classList.remove('is-active'));
					pane.classList.add('is-active');

					if (closingPaneShow) {
						closingPaneShow.style.transition = '';
						closingPaneShow.style.opacity = '';
						closingPaneShow.style.gridTemplateRows = '';
					}

					setTimeout(() => {
						pane.classList.remove('is-transitioning');
					}, 400);
				}, 150);
			});
		});
	}
	#initMobile(panes) {
		panes.forEach(p => p.classList.remove('is-active'));

		let ticking = false;
		const buffer = 100; // pixels voorbij center voordat het activeert

		const updateActivePane = () => {
			const center = window.innerHeight / 2 - buffer;
			let closestPane = null;
			let closestDistance = Infinity;

			panes.forEach(pane => {
				const rect = pane.getBoundingClientRect();
				const paneCenter = rect.top + rect.height / 2;
				const distance = Math.abs(paneCenter - center);

				if (distance < closestDistance) {
					closestDistance = distance;
					closestPane = pane;
				}
			});

			if (closestPane && !closestPane.classList.contains('is-active')) {
				panes.forEach(p => p.classList.remove('is-active'));
				closestPane.classList.add('is-active');
			}

			ticking = false;
		};

		window.addEventListener('scroll', () => {
			if (!ticking) {
				requestAnimationFrame(updateActivePane);
				ticking = true;
			}
		});

		updateActivePane();
	}
}

export default new PaneGroup();
